import { connect } from "react-redux";
import { fetchPickBorrowingStats } from "./state/actions";
import PickBorrowingListComponent from "./PickBorrowingList";

const mapStateToProps = (state) => {
  const statsData = state.statsPickBorrowing || {};

  return {
    data: statsData.data || {
      byHour: [],
      byDay: {},
      byWeek: {},
      byMonth: {},
    },
    error: statsData.error || null,
    isLoading: statsData.isLoading || false,
    hasError: statsData.hasError || false,
  };
};

const mapDispatchToProps = {
  fetchPickBorrowingStats,
};

export const PickBorrowingList = connect(
  mapStateToProps,
  mapDispatchToProps
)(PickBorrowingListComponent);
